import { render, staticRenderFns } from "./BookingProductListItem.vue?vue&type=template&id=30c035ea"
import script from "./BookingProductListItem.vue?vue&type=script&lang=ts"
export * from "./BookingProductListItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports